import React from 'react';
import { styled, Tooltip } from '@material-ui/core';
import { TruncatedChip } from '../../../shared/components';

interface ChipSetProps {
  max: number;
  values: string[];
  hideTooltip?: boolean;
}

const Container = styled('div')({
  display: 'flex',
  gap: 4,
  alignItems: 'center',
  height: '100%',
  minWidth: 0,
  overflow: 'hidden',
});

export const ChipSet = ({
  max,
  values = [],
  hideTooltip = false,
}: ChipSetProps) => {
  const chipsToShow = values.slice(0, max);
  const remainingChipsCount = values.length - chipsToShow.length;
  const hasMultipleChips = chipsToShow.length > 1;
  const value = hideTooltip ? '' : values.join(', ');
  return (
    <Tooltip title={value}>
      <Container>
        {chipsToShow.map((label: string, index: number) => {
          const keepFullWidth = index === 0 && hasMultipleChips;

          return (
            <TruncatedChip
              color="primary"
              key={label}
              label={label}
              style={{ flexShrink: keepFullWidth ? 0 : 1 }}
            />
          );
        })}
        {remainingChipsCount > 0 && (
          <>
            ...
            <TruncatedChip
              label={`+${remainingChipsCount}`}
              variant="outlined"
              style={{ flexShrink: 0 }}
            />
          </>
        )}
      </Container>
    </Tooltip>
  );
};
